import {
  FormTheme,
  MultiStepForm,
  MultiStepFormRouter,
} from '@kanda-libs/ks-component-ts';

import { Pages, STEPS } from './Form-constants';
import useCompanyInfoForm from './useCompanyInfoForm';

const ViewComponent = ({}) => {
  const { initialStepIndex, initialData } = useCompanyInfoForm();

  if (initialStepIndex === null) return null;

  return (
    <FormTheme variant="default">
      <MultiStepForm
        steps={STEPS}
        addStepsToUrl={false}
        initialStepIndex={initialStepIndex}
        initialData={initialData}
      >
        <MultiStepFormRouter pages={Pages} />
      </MultiStepForm>
    </FormTheme>
  );
};

ViewComponent.displayName = 'Form-view';

export default ViewComponent;
